import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

export type BackRole = 'ROLE_ADMIN' | 'ROLE_QUALITY' | 'ROLE_DATA_ENTRY';

export const canMatchByRole: CanMatchFn = (
    route: Route,
    _segs: UrlSegment[]
) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    const userRoles: string[] = (auth.userData?.roles ?? []) as string[];

    // Admin = master key
    if (userRoles.includes('ROLE_ADMIN')) return true;

    // Our convention: empty or missing roles = admin-only
    const required = (route.data?.['roles'] as BackRole[] | undefined) ?? [];
    if (required.length === 0) return router.createUrlTree(['/unauthorized']);

    const ok = required.some((r) => userRoles.includes(r));
    return ok ? true : router.createUrlTree(['/unauthorized']);
};
